import React, { useState, useEffect } from 'react';
import './App.css';

import LoadingScreen from './components/common/LoadingScreen';
import Navigation from './components/common/Navigation';
import Hero from './components/sections/hero/Hero';
import About from './components/sections/about/About';
import Memberships from './components/sections/memberships/Memberships';
import Locations from './components/sections/locations/Locations';
import Footer from './components/sections/footer/Footer';
import useScrollSpy from './hooks/useScrollSpy';
import Instructions from './components/sections/instructions/Instructions';
import useIntersectionObserver from './hooks/useIntersectionObserver';
import DownloadSection from './components/sections/download/DownloadSection';
import useApi from './hooks/useApi';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { carWashes, membershipPlans, loading } = useApi();
  const activeSection = useScrollSpy(['home', 'instructions','about', 'memberships', 'locations']);
  
  useIntersectionObserver();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMenuOpen(false);
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="App">
      <Navigation 
        activeSection={activeSection}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        scrollToSection={scrollToSection}
      />
      <Hero scrollToSection={scrollToSection} />
      <DownloadSection />
      <Instructions />
      <About />
      <Memberships membershipPlans={membershipPlans} />
      <Locations carWashes={carWashes} />
      <Footer carWashes={carWashes} scrollToSection={scrollToSection} />
    </div>
  );
}

export default App;